export const inputModificationMixin = {
    methods: {
        keydownAllSymbolExeptSpace: function (e) {
            const keySpace = 32;
            if (e.keyCode === keySpace) {
                e.preventDefault();
            }
        },
        keydownOnlyRussianChars: function (e) {
            const keySpace = 32;
            if (!(e.ctrlKey || e.altKey || e.metaKey || e.keyCode < keySpace)) {
                const regex = /[\u0410-\u044Fu0401\u0451-]/;
                if (!regex.test(e.key)) {
                    e.preventDefault();
                }
            }
        },
        keydownOnlyLetters: function (e) {
            const keySpace = 32;
            if (!(e.ctrlKey || e.altKey || e.metaKey || e.keyCode < keySpace)) {
                const regex = /[\u0410-\u044F\u0401\u0451a-zA-Z'-]/;
                if (!regex.test(e.key)) {
                    e.preventDefault();
                }
            }
        },
        keydownOnlyDigits: function (e) {
            const keyDelete = 46;
            const keySpace = 32;
            if (!(e.ctrlKey || e.altKey || e.metaKey || (e.keyCode <= keyDelete && e.keyCode !== keySpace))) {
                const regex = /[0-9]/;
                if (!regex.test(e.key)) {
                    e.preventDefault();
                }
            }
        },
    },
};


// WEBPACK FOOTER //
// ./common/mixins/inputModificationMixin.ts